import { render, staticRenderFns } from "./CouponStatistics.vue?vue&type=template&id=418d4770&"
import script from "./CouponStatistics.vue?vue&type=script&lang=js&"
export * from "./CouponStatistics.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports